// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__3BD9W","icon":"tooltip_icon__1Jzcw","content":"tooltip_content__2UsEf","show":"tooltip_show__SSQar","bottom":"tooltip_bottom__33WSU"};